module.exports = __webpack_public_path__ + "static/media/icono_maquillaje.0812b235.svg";